import React from 'react';
import PropTypes from "prop-types";

export function CsfPivotalFournisseurRecognitionDetailsTab2({formDetail}) {

  const langcode = document.documentElement.lang;

  return (
    <div className="tab-panel hide" id="training-tab" role="tabpanel">
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          Description [FR]
        </div>
        <div className="tab-line-value">
          {formDetail.Desc_French}
        </div>
      </div>
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.recognition.detail.description')}
        </div>
        <div className="tab-line-value">
          {formDetail.Desc_English}
        </div>
      </div>
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_exclusive_offer')}
        </div>
        <div className="tab-line-value">
          {formDetail.For_Company_Only ? (
            window.Drupal.t('Yes')
          ) : (
            window.Drupal.t('No')
          )}
        </div>
      </div>
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.recognition.detail.wider.public')}
        </div>
        <div className="tab-line-value">
          {formDetail.Contact_For_CSF_WebSite === true ? (
            window.Drupal.t('Yes')
          ) : (
            window.Drupal.t('No')
          )}
        </div>
      </div>
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.creation_form.form.fields.training.chk_cost')}
        </div>
        <div className="tab-line-value">
          {formDetail.Amount && (
            formDetail.Amount +'$'
          )}
        </div>
      </div>
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.creation_form.form.fields.difficulty.sel_label')}
        </div>
        <div className="tab-line-value">
          {formDetail.Difficulty === 0 ? (
            window.Drupal.t('fournisseur.training.difficulty.beginner')
          ) : formDetail.Difficulty === 1 ? (
            window.Drupal.t('fournisseur.training.difficulty.intermediate')
          ) : formDetail.Difficulty === 2 ? (
            window.Drupal.t('fournisseur.training.difficulty.advance')
          ) : null}
        </div>
      </div>
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.creation_form.form.fields.targetted_clients')}
        </div>
        <div className="tab-line-value">
          {formDetail.Audience__Secondary &&
            formDetail.Audience__Secondary.map((val) => (
              <p key={val.Subject_Id}>
                {langcode === 'fr' ? val.Name_French : val.Name_English}
              </p>
            ))
          }
        </div>
      </div>
      <div className="tab-line-item d-flex align-items-center">
        <div className="tab-line-title">
          {window.Drupal.t('fournisseur.creation_form.form.fields.training_type.sel_label')}
        </div>
        <div className="tab-line-value">
          { langcode === 'fr' ? formDetail.EP_Type_French : formDetail.EP_Type_English }
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurRecognitionDetailsTab2.propTypes = {
  formDetail: PropTypes.object
};
